import { render, staticRenderFns } from "./CytomineStorage.vue?vue&type=template&id=6878e592&scoped=true"
import script from "./CytomineStorage.vue?vue&type=script&lang=js"
export * from "./CytomineStorage.vue?vue&type=script&lang=js"
import style0 from "./CytomineStorage.vue?vue&type=style&index=0&id=6878e592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878e592",
  null
  
)

export default component.exports